export default function (time: Date): any[] {
    const timestamp = time.getTime(); 
    const milliseconds = Date.now() - timestamp;
    const minutes = Math.floor(milliseconds / (1000 * 60));
    const hours = Math.floor(minutes / 60);
    if (minutes < 1)
        return ["Just now", 60 * 1000];
    if (minutes === 1)
        return [`1 minute ago`, 60 * 1000];
    if (hours < 1)
        return [`${minutes} minutes ago`, 60 * 1000];
    if (hours === 1)
        return [`1 hour ago`, 60 * 60 * 1000];
    if (hours < 5)
        return [`${hours} hours ago`, 60 * 60 * 1000 * (5 - hours)];
    if (hours <= 24)
        return ["today", 60 * 60 * 1000 * (24 - hours)];
    if (hours <= 48)
        return ["yesterday", 60 * 60 * 1000 * (48 - hours)];
    return [new Date (milliseconds).toLocaleDateString(), null]; 
}



// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Utils/timestamp.ts